import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SegmentedControl } from '@ui/components/common/micro-interactions';
// Same API as before; rendered as the brand segmented control (openspec: add-subtle-portal-micro-interactions).
export const Tabs = ({ tabs, activeTab, onChange, ariaLabel = 'Filter' }) => {
    return _jsx(SegmentedControl, { options: tabs, value: activeTab, onChange: (value) => onChange(value), ariaLabel: ariaLabel, fullWidth: true });
};
